module.exports = __webpack_public_path__ + "html/studio-header_cf4bb9128631308967c34e81c96aaab6.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/studio-header.html
// module id = 1aEF
// module chunks = 51